<template>
  <v-container grid-list-md class="news-card-container" :class="{'px-0': $vuetify.breakpoint.smAndDown}">
      
        <div class="flex xs12 section-header">{{ sourceName }}</div>

        <section class="card-list opacity-0 no-scrollbar lozad">
          <div 
              v-for="(item, idx) in articles"
              :key="idx"
          >
            <v-card class="card news-card item ma-2" :elevation="2" :href="item.url" target="_blank" rel="noopener noreferrer">
                <v-img v-if="item.urlToImage != null && item.urlToImage.length > 0"
                  class="card-thumb"
                  :src="item.urlToImage"
                />
                <v-img v-else
                  class="card-thumb"
                  src="../assets/logo.png"
                />
                <v-card-title>
                    <v-flex text-xs-left class="card-title"
                      style="cursor: pointer"
                      v-html="truncateText(item.title, 130, '...')"
                    >
                    </v-flex>
                </v-card-title>
            </v-card>
          </div>
        </section>
   </v-container>
</template>

<script>
import newsApi from '../services/ApiService'
import lozad from 'lozad'

export default {
  name: 'NewsCards',
  props: [
      'newsSource'],
  data () {
    return {
      articles: [],
      sourceName: '',
      show: false,
      loading: false,
      noData: false
    }
  },
  methods: {
    fetchNewsData () {
      newsApi.fetchNews(this.newsSource)
        .then(response => {
          // eslint-disable-next-line no-console
          console.log(response)
          if (Object.keys(response).length) {
            // this.articles = this.articles.concat(response)
            this.articles = response.articles
            this.sourceName = response.articles[0].source.name
            this.loading = false
            this.noData = false
          } else {
            this.noData = true
            this.loading = false
          }
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log(error)
        })
    },
    loadImages () {
      const observer = lozad('.lozad', {
          rootMargin: '100px 0px', // like css margin
          // threshold: 0.1 // ratio of element convergence
          loaded: function(el) {
              // Custom implementation on a loaded element
              el.classList.add('loaded');
              // el.classList.remove('loading-blur');
          }
      });

      observer.observe();
    },
    truncateText (text, length, suffix) {
      if (text.length > length) {
        return text.substring(0, length) + suffix
      }
      else {
        return text
      }
    }
  },
  mounted () {
    this.fetchNewsData(),
    this.loadImages()
  },
  computed: {
    flex () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 12
        case 'sm': return 6
        case 'md': return 4
        case 'lg': return 3
        case 'xl': return 3
        default: return 3
      }
    }
  }
}

</script>

<style lang="scss" scoped>
  .news-card {
    height: 250px;
    //max-height: 250px;
    //min-height: 250px;

    .card-thumb {
      height: 150px;
      // min-height: 150px;
      // max-height: 150px;
    }

  }
</style>
